import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { motion } from "framer-motion"

export const buttonStyle = css`
  text-decoration: none;
  display: inline-flex;
  justify-content: start;
  flex-direction: row;
  height: 51px;
  gap: 20px;
  align-items: start;
  text-align: start;
  line-height: 1;
  font-size: 16px;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: filter 0.3s ease-in-out;
  width: fit-content;
  box-sizing: border-box;
  border: 0;
  position: relative;
  color: var(--text-color);
  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    bottom: 25px;
    height: 6px;
    background-color: var(--primary);
    transition: background 0.2s ease-in-out;
  }
  &:hover {
    &:after {
      background-color: var(--secondary);
    }
  }

  &:hover {
    filter: saturate(1.3);
  }

  &:disabled {
    opacity: 0.8;
    cursor: default;
  }
`

const StyledLink = styled(Link)`
  ${buttonStyle}
`

const StyledAnchor = styled.a`
  ${buttonStyle}
`

const StyledButton = styled.button`
  ${buttonStyle}
`

const IconWrapper = styled.div`
  margin-top: -1px;
`
const AnimatedDiv = styled(motion.div)`
  display: inline-block;
`
const Animation = ({ children }) => {
  return (
    <AnimatedDiv
      className="btn"
      whileHover={{
        scale: 1.05,
      }}
      whileTap={{ scale: 0.95 }}
    >
      {children}
    </AnimatedDiv>
  )
}

const Button = props => {
  let icon = null
  if (props.icon) {
    icon = <IconWrapper>{props.icon}</IconWrapper>
  }

  if (props.submit) {
    return (
      <Animation>
        <StyledButton
          type="submit"
          $fill={props.fill}
          style={props.style}
          direction={props.direction}
          $disabled={props.disabled}
        >
          {props.label}
          {icon}
        </StyledButton>
      </Animation>
    )
  }

  if (props.to) {
    return (
      <Animation>
        <StyledLink
          to={props.to}
          $inversed={props.inversed}
          $fill={props.fill}
          $primary={props.primary}
          style={props.style}
        >
          {props.label}
          {icon}
        </StyledLink>
      </Animation>
    )
  }

  if (props.href) {
    return (
      <Animation>
        <StyledAnchor
          href={props.href}
          $inversed={props.inversed}
          $fill={props.fill}
          $primary={props.primary}
          style={props.style}
          target={props.external ? "_blank" : null}
          rel={props.external ? "noreferrer" : null}
        >
          {props.label}
          {icon}
        </StyledAnchor>
      </Animation>
    )
  }

  return (
    <Animation>
      <StyledButton
        onClick={props.onClick}
        $inversed={props.inversed}
        $fill={props.fill}
        $primary={props.primary}
        style={props.style}
      >
        {props.label}
        {icon}
      </StyledButton>
    </Animation>
  )
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.element,
  external: PropTypes.bool,
  fill: PropTypes.bool,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  fill: false,
  primary: false,
  disabled: false,
  external: false,
}

export { Button }
